<template>
  <div>
    <div class="title">Integrations</div>
    <div class="integrations">
      <div
        class="integration"
        v-for="integration in integrations"
        :key="integration.value"
        :class="{'active' : block.config.notificationConfig.forwardType == integration.value}"
        @click="block.config.notificationConfig.forwardType = integration.value; saveBlockDebounced(block)"
      >
        <div class="img-wrapper">
          <img class="integration-image" :src="integration.img" v-if="integration.img" />
        </div>
        <div class="integration-name">{{ integration.text }}</div>
      </div>
    </div>
    <v-alert
      v-if="block.config.notificationConfig.forwardType === 'FORWARD_EMAIL'"
      type="info"
    >Send captured information from your customers as e-mail to your email address</v-alert>
    <v-alert
      v-if="block.config.notificationConfig.forwardType === 'FORWARD_SLACK'"
      type="info"
    >Send captured information from your customers as e-mail to a Slack webhook.</v-alert>
    <v-alert
      v-if="block.config.notificationConfig.forwardType === 'FORWARD_TELEGRAM'"
      type="info"
    >Send captured information from your customers as e-mail to a Telegram channel.</v-alert>
    <v-alert
      v-if="block.config.notificationConfig.forwardType === 'FORWARD_ZAPIER'"
      type="info"
    >Send captured information from your customers as e-mail to a Zapier webhook.</v-alert>

    <v-text-field
      v-if="block.config.notificationConfig.forwardType === 'FORWARD_EMAIL'"
      :value="block.config.notificationConfig.forwardAddress"
      outlined
      dense
      label="Forward E-mail address"
      placeholder="Forward E-mail address"
      autocomplete="off"
      type="email"
      @change="onInputChange($event, ['config', 'notificationConfig', 'forwardAddress'])"
    ></v-text-field>
    <v-text-field
      v-if="block.config.notificationConfig.forwardType === 'FORWARD_TELEGRAM'"
      :value="block.config.notificationConfig.telegramBotId"
      outlined
      dense
      label="Telegram Bot Id"
      placeholder="Telegram Bot Id"
      autocomplete="off"
      type="text"
      @change="onInputChange($event, ['config', 'notificationConfig', 'telegramBotId'])"
    ></v-text-field>
    <v-text-field
      v-if="block.config.notificationConfig.forwardType === 'FORWARD_TELEGRAM'"
      :value="block.config.notificationConfig.telegramChannelId"
      outlined
      dense
      label="Telegram Channel Id"
      placeholder="Telegram Channel Id"
      autocomplete="off"
      type="text"
      @change="onInputChange($event, ['config', 'notificationConfig', 'telegramChannelId'])"
    ></v-text-field>
    <v-text-field
      v-if="block.config.notificationConfig.forwardType === 'FORWARD_SLACK'"
      :value="block.config.notificationConfig.slackWebHookUrl"
      outlined
      dense
      label="Slack Webhook Url"
      placeholder="Slack Webhook Url"
      autocomplete="off"
      type="text"
      @change="onInputChange($event, ['config', 'notificationConfig', 'slackWebHookUrl'])"
    ></v-text-field>
    <v-text-field
      v-if="block.config.notificationConfig.forwardType === 'FORWARD_ZAPIER'"
      :value="block.config.notificationConfig.zapier.webHookUrl"
      outlined
      dense
      label="Zapier Webhook Url"
      placeholder="Zapier Webhook Url"
      autocomplete="off"
      type="text"
      @change="onInputChange($event, ['config', 'notificationConfig', 'zapier', 'webHookUrl'])"
    ></v-text-field>
    <div v-if="block.config.notificationConfig.forwardType === 'FORWARD_ZAPIER'">
      <v-alert
        dense
        text
        border="left"
        type="warning"
      >Landly will send the following body to the given Zapier webhook:</v-alert>
      <pre>
         {{ getZapierBody }}
      </pre>
    </div>
    <v-alert
      dense
      text
      border="left"
      type="info"
      v-if="block.config.notificationConfig.forwardType !== 'NONE'"
    >You can test this configuration in your live site.</v-alert>
  </div>
</template>

<script>
import projectMixin from "../project-mixin";
export default {
  mixins: [projectMixin],
  props: ["block"],
  computed: {
    getZapierBody() {
      var dict = {};

      if (this.block.type === "CONTACT") {
        this.block.config.items.map(r => {
          dict[r.title] = "";
        });
      }

      if (this.block.type === "EMAIL_CAPTURE") {
        dict["Email"] = "";
      }

      return dict;
    }
  },
  data() {
    return {
      integrations: [
        {
          value: "NONE",
          text: "None",
          img: ""
        },
        {
          value: "FORWARD_EMAIL",
          text: "E-mail",
          img:
            "https://cdn0.iconfinder.com/data/icons/social-icons-20/200/mail-icon-512.png"
        },
        {
          value: "FORWARD_SLACK",
          text: "Slack",
          img:
            "https://upload-icon.s3.us-east-2.amazonaws.com/uploads/icons/png/11198185071580802972-512.png"
        },
        {
          value: "FORWARD_TELEGRAM",
          text: "Telegram",
          img:
            "https://cdn0.iconfinder.com/data/icons/social-media-2092/100/social-56-512.png"
        },
        {
          value: "FORWARD_ZAPIER",
          text: "Zapier",
          img: "https://cdn.iconscout.com/icon/free/png-512/zapier-282557.png"
        }
      ]
    };
  },
  methods: {
    onInputChange(value, prop) {
      this.UPDATE_BLOCK_PROP({ id: this.block.id, prop, value });
    }
  }
};
</script>

<style scoped>
.integrations {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-content: flex-start;
  overflow: auto;
}
.integration {
  width: 100px;
  height: 100px;
  cursor: pointer;
  margin-bottom: 30px;
  transition: 300ms all;
  position: relative;
  border-radius: 6px;
  overflow: hidden;
  border: 1px solid #e7e7e7;
  border-radius: 3px;
  box-shadow: 0 6px 14px 0 rgba(33, 35, 68, 0.05);
  display: flex;
  flex-direction: column;
}
.integration:hover {
  border: 1px solid #292961;
}
.integration.active {
  border: 2px solid green;
}
.integration-image {
  width: 50px;
  height: 50px;
  align-self: center;
}
.img-wrapper {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.integration-name {
  border-top: 1px solid #ddd;
  background: #f9f9f9;
  text-transform: uppercase;
  font-size: 16px;
  color: #555555;
  text-align: center;
}
</style>